<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-08 19:38:16
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:48:20
 * @name: 编辑人员
 * @Description: 编辑人员
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\dialog\edit-people.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <addNeditDialog
    ref="addNeditDialog"
    title="设置密码"
    bar-title="密码"
    @close="close"
  >
    <template v-slot:form>
      <div class="line">
        <font class="label">密码:</font>
        <el-input
          type="password"
          class="input"
          v-model="password"
          placeholder="请输入密码"
        ></el-input>
      </div>
    </template>
    <template v-slot:btnGroup>
      <el-button type="primary" @click="save">保存</el-button>
      <el-button plain @click="cancel">取消</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import { confirmation, debounceation } from "@/utils/decorator";
import addNeditDialog from "./addNeditDialog";
export default {
  name: "mailList-Content-editPeople",
  components: {
    addNeditDialog,
  },
  props: {
    mailList: {
      type: Object,
    },
  },
  data() {
    return {
      id: "",
      password: "",
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开dialog
     * @params row 携带信息
     */
    open(row) {
      this.id = row.id;
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击保存
     */
    @confirmation("确认保存?")
    save() {
      this.mailList
        .setPassword({
          id: this.id,
          password: this.password,
        })
        .then((res) => {
          this.cancel();
          this.$emit("updateHandler");
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击取消
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭回调,初始化
     */
    close() {
      this.id = "";
      this.password = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 400px;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
  }
  .input {
    flex: 1;
  }
}
.el-button {
  margin-left: 40px;
  width: $Var-button-width-normal;
  &:first-child {
    margin-left: 0;
  }
}
</style>
